// extracted by mini-css-extract-plugin
module.exports = {"error":"ItemRejectionPopup_error__o0u0w"};